import { useEffect } from 'react';

/**
 * Google Analytics component that loads only when REACT_APP_GA_MEASUREMENT_ID is set
 * This allows disabling GA in development by not setting the env variable
 */
const GoogleAnalytics: React.FC = () => {
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

    useEffect(() => {
        // Only load GA if measurement ID is provided
        if (!measurementId) {
            console.info('Google Analytics disabled: REACT_APP_GA_MEASUREMENT_ID not set');
            return;
        }

        // Load gtag.js script
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        script.async = true;
        document.head.appendChild(script);

        // Initialize gtag
        window.dataLayer = window.dataLayer || [];
        function gtag(...args: any[]) {
            window.dataLayer.push(args);
        }
        gtag('js', new Date());
        gtag('config', measurementId);

        console.info(`Google Analytics enabled with ID: ${measurementId}`);

        // Cleanup script on unmount
        return () => {
            const scriptElement = document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`);
            if (scriptElement) {
                scriptElement.remove();
            }
        };
    }, [measurementId]);

    return null; // This component doesn't render anything
};

// TypeScript declaration for window.dataLayer
declare global {
    interface Window {
        dataLayer: any[];
    }
}

export default GoogleAnalytics;
